import { Pipe, type PipeTransform } from '@angular/core';

import { SERVICE_LOGICAL_STATUS, type ServiceLogicalStatus } from '../models/services.model';

@Pipe({
  name: 'serviceLogicalStatus',
  standalone: true,
})
export class ServiceLogicalStatusPipe implements PipeTransform {
  transform(status: ServiceLogicalStatus): string {
    switch (status) {
      case SERVICE_LOGICAL_STATUS.INACTIVE:
        return 'inactive';
      case SERVICE_LOGICAL_STATUS.ACTIVE:
        return 'active';
      case SERVICE_LOGICAL_STATUS.UPDATING:
        return 'updating';
      case SERVICE_LOGICAL_STATUS.DEPRECATED:
        return 'deprecated';
      case SERVICE_LOGICAL_STATUS.DELETED:
        return 'deleted';
      case SERVICE_LOGICAL_STATUS.REQUESTED:
        return 'requested';
      default:
        return '';
    }
  }
}
